export function compareArrays(
  oldArray: string[],
  newArray: string[],
): { added: string[]; deleted: string[] } {
  const added: string[] = [];
  const deleted: string[] = [];

  // Find items in newArray that don't exist in oldArray (added)
  newArray.forEach((item) => {
    if (!oldArray.includes(item)) {
      added.push(item);
    }
  });

  // Find items in oldArray that don't exist in newArray (deleted)
  oldArray.forEach((item) => {
    if (!newArray.includes(item)) {
      deleted.push(item);
    }
  });

  return { added, deleted };
}
